import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" ANGEL LEAGUE SeoulPunks ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Activity ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ANGEL LEAGUE SeoulPunks에서 판매된 작품들이에요! ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" SeoulPunks 더보러 가기 ")

import {computed} from 'vue'
import {AgBoxS, AgIconS} from '@/components/ag'
import NftItem from './NftItem.vue'
import nftPng from './assets/nft.png'
import openSeaPng from './assets/open-sea.png'
import SeeMore from '../SeeMore.vue'
import {useQuery} from '@vue/apollo-composable'
import gql from 'graphql-tag'
import {useInAppBrowser, provideTrackPayload} from '@/composables'
import {fromWei} from 'web3-utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

provideTrackPayload({
  clickArea: '서울펑크',
})

const inAppBrowser = useInAppBrowser('https://abit.ly/alspk', '_black', {presentationStyle: 'fullscreen', toolbar: true})

const {result} = useQuery(gql`
  query {
    seoulPunks: items (
       collectionName: "seoulPunk", perPage: 6, randomFlag: true
    ) {
      id
      imageUrl
      title
      quantity
      detailUri
      collection {
        chain
      }
    }
  }
`)

const onOpenSite = () => {
  inAppBrowser.open()
}

const onVisitLink = (url: string) => {
  inAppBrowser.open(url)
}

const list = computed(() => {
  return (result.value?.seoulPunks ?? []).map((item: any) => {
    const {collection: {chain} = {} as any, title, quantity, detailUri, imageUrl, id} = item
    return {
      chainKind: chain,
      chainQuantity: quantity ? fromWei(quantity, 'ether') : undefined,
      id,
      imgSrc: imageUrl,
      link: detailUri,
      title,
    }
  })
})



return (_ctx: any,_cache: any) => {
  const _directive_track = _resolveDirective("track")!

  return (_openBlock(), _createBlock(_unref(AgBoxS), null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_unref(AgBoxS), {
        css: {dp: 'flex', direction: 'row', alignItems: 'center', cursor: 'pointer', mb: 16},
        onClick: onOpenSite
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), {
            "container-as": "img",
            src: _unref(nftPng),
            css: {width: 32, height: 32, mr: 8}
          }, null, 8, ["src"]),
          _createVNode(_unref(AgBoxS), { css: {typography: 'h7', fontWeight: 'bold', mr: 8} }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), {
            "container-as": "img",
            src: _unref(openSeaPng),
            css: {width: 16, height: 16, mr: 8}
          }, null, 8, ["src"]),
          _createVNode(_unref(AgIconS), {
            name: "chevronForward",
            css: {width: 16, height: 16, mr: 8, color: 'gray2'}
          })
        ]),
        _: 1
      }, 512), [
        [_directive_track, {clickContent: '서울펑크로 링크'}]
      ]),
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'row'} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgIconS), {
            css: {width: 24, height: 24, mr: 4},
            name: "trendingUpSharp"
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'h5', fontWeight: 'bold', mb: 8} }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {typography: 'h9', fontWeight: 'normal', color: '#5E6068'} }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {dp: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px', py: 16} }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
            return (_openBlock(), _createBlock(NftItem, _mergeProps({
              key: item.id
            }, item, { onVisitLink: onVisitLink }), null, 16))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SeeMore, { onClick: onOpenSite }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 512), [
            [_directive_track, {clickContent: '더보기'}]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})